<template>
  <div :class="$style.root">
    <h1>ТОП 100 Теги сайтов</h1>
    <p>Страница для управления тегами сайтов ТОП 100</p>
  </div>
</template>

<script>
export default {
  name: 'Top100SiteTags',
  data() {
    return {};
  },
};
</script>

<style lang="scss" module>
@import "~@/ui-kit/_theme/main.scss";

.root {
  padding: $gap-m;
}
</style>
